var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_1030_19689_00000016792333888992142780000005925612201737068421_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#0E9384;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 17.9,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 17.9,
    height: 17.9,
    id: "mask0_1030_19689_00000016792333888992142780000005925612201737068421_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,20c1,0.5,2,0.8,3.2,1v-1c-2-0.3-3.7-1.2-5-2.7C4.7,15.8,4,14,4,12c0-2,0.7-3.8,2-5.3C7.4,5.2,9,4.3,11,4 V3C8.7,3.3,6.8,4.3,5.3,6C3.8,7.7,3,9.7,3,12c0,1.1,0.2,2.2,0.6,3.3c0.4,1,1,2,1.7,2.8C6,18.8,6.9,19.5,7.8,20z M13,20v1 c0.8-0.1,1.7-0.3,2.4-0.7c0.8-0.3,1.5-0.7,2.2-1.2l-0.8-0.7c-0.6,0.4-1.2,0.8-1.8,1.1C14.4,19.7,13.7,19.9,13,20z M15.1,4.6 c0.7,0.3,1.3,0.6,1.9,1.1l0.7-0.8C17,4.4,16.2,4,15.5,3.7C14.7,3.4,13.9,3.2,13,3v1C13.7,4.1,14.4,4.3,15.1,4.6z M18.3,16.9 l0.7,0.7c0.5-0.7,0.9-1.4,1.3-2.2c0.3-0.8,0.5-1.6,0.6-2.4h-1c-0.1,0.7-0.3,1.4-0.6,2.1C19.1,15.7,18.8,16.3,18.3,16.9z M19.4,8.9 c0.3,0.7,0.5,1.3,0.6,2.1h1c-0.1-0.8-0.3-1.7-0.7-2.4C20,7.8,19.6,7,19.1,6.3l-0.7,0.8C18.8,7.7,19.1,8.3,19.4,8.9z M13.4,13.4 C13,13.8,12.6,14,12,14s-1-0.2-1.4-0.6C10.2,13,10,12.6,10,12s0.2-1,0.6-1.4C11,10.2,11.4,10,12,10s1,0.2,1.4,0.6 C13.8,11,14,11.4,14,12S13.8,13,13.4,13.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusIcon);
export default __webpack_public_path__ + "static/media/payment-status-icon.2524421441572e871c513b2262d67af3.svg";
export { ForwardRef as ReactComponent };